// Port of src/app/components/nav-bar/dropdowns/menu-dropdown/
// menu-dropdown.component.{ts,html,scss} (mypart-menu-dropdown).
//
// Same portal/backdrop strategy as the filter dropdowns. setPosition(top, 0)
// arrives as the `position` style; :host width calc(100% - 2rem) lives in
// MenuDropdown.scss (.menu-dropdown-host).

import type { CSSProperties } from 'react';
import { createPortal } from 'react-dom';
import { ModalType } from '../../interfaces/modal-types.enum';
import { useModalStore } from '../../stores/modal-store';
import { useGlobalStore } from '../../stores/global-store';
import { useUserStore } from '../../stores/user-store';
import { trimUrlForPopups } from '../../api/http-req';
import { useOutsideClick } from '../../shared/hooks/useOutsideClick';
import './MenuDropdown.scss';

export interface MenuDropdownProps {
  position: CSSProperties;
  onOutsideDropdownClick: () => void;
}

function trimUrl(url: string): string {
  const parts = url.split('/');
  return parts.slice(0, 3).join('/'); // Keep only the first 3 parts
}

export default function MenuDropdown({ position, onOutsideDropdownClick }: MenuDropdownProps) {
  const user = useUserStore(s => s.user);

  const outsideClick = () => onOutsideDropdownClick();

  const panelRef = useOutsideClick<HTMLDivElement>(outsideClick);

  const navigateToPlaylists = () => {
    let newUrl = trimUrlForPopups(window.location.href, '/playlist/') + 'playlist/top-playlists/';
    newUrl = trimUrl(newUrl);
    newUrl += '/playlist/top-playlists/';
    window.history.pushState({}, 'Songhunt', newUrl);
    useGlobalStore.getState().setGlobalField('showCuratedPlaylists', true);
    outsideClick();
  };

  const showAffiliationModal = () => {
    useModalStore.getState().open(ModalType.AFFILIATION_LINK);
    outsideClick();
  };

  return createPortal(
    <>
      <div className="overlay-backdrop" style={{ zIndex: 49 }} onClick={onOutsideDropdownClick} />
      <div className="menu-dropdown-host" style={position}>
        <div ref={panelRef} className="menu-dropdown-container">
          <ul>
            <li>
              <a href="https://www.mypart.ai/songhunt" target="_blank">About Songhunt</a>
            </li>
            <li>
              <a href="https://www.mypart.ai/" target="_blank">About MyPart</a>
            </li>
            <li>
              <a href="https://www.mypart.ai/api-access" target="_blank">API Access</a>
            </li>
            <li>
              <a onClick={navigateToPlaylists}>Top Playlists</a>
            </li>
            {user && (
              <li>
                <a onClick={showAffiliationModal}>Ambassador Program</a>
              </li>
            )}
            <li>
              <a href="https://www.mypart.net/contact" target="_blank">Contact</a>
            </li>
          </ul>
        </div>
      </div>
    </>,
    document.body
  );
}
